import { HTMLAttributes } from "react"

export default function PostMark(props: HTMLAttributes<SVGElement>) {
  return (
    <svg {...props} viewBox="0 0 90 90" xmlns="http://www.w3.org/2000/svg">
      <g fill="none" fillRule="evenodd">
        <path
          d="M6 0h12.947v4.737h18.948V0h14.208v4.736H71.05V0H84a6 6 0 0 1 6 6v12.947h-4.737v18.948H90v14.21h-4.737v18.948H90V84a6 6 0 0 1-6 6H71.05v-4.738H52.103V90H37.895v-4.737H18.947V90H6a6 6 0 0 1-6-6V71.053h4.737V52.105H0v-14.21h4.736V18.947H0V6a6 6 0 0 1 6-6Zm52.26 46.11c2.558-2.578 3.838-5.941 3.838-10.09 0-3.344-.584-6.023-1.753-8.037-1.168-2.034-3.102-3.545-5.8-4.532-2.68-.987-6.305-1.48-10.877-1.48h-16.95v5.68h5.68v34.17h-5.68v5.68h18.49v-5.68h-5.92V50.038h5.981c6.103-.04 10.434-1.35 12.992-3.928Zm-5.65-16.465c1.673 1.309 2.508 3.384 2.508 6.223 0 2.236-.392 3.988-1.178 5.257-.785 1.25-2.014 2.135-3.686 2.66-1.671.503-3.907.754-6.707.754h-4.26V27.651h4.743c4.049 0 6.91.664 8.58 1.994Z"
          fill="#FADE4B"
        />
        <path
          d="M62.098 36.02c0 4.148-1.28 7.512-3.837 10.09-2.559 2.578-6.889 3.888-12.992 3.928h-5.982V61.82h5.922v5.68h-18.49v-5.68h5.68V27.65h-5.68v-5.68h16.949c4.572 0 8.197.493 10.877 1.48 2.698.987 4.632 2.498 5.8 4.532 1.169 2.014 1.753 4.693 1.753 8.037Zm-6.98-.152c0-2.84-.835-4.914-2.507-6.223-1.672-1.33-4.532-1.994-8.58-1.994h-4.744v16.888h4.26c2.8 0 5.036-.252 6.707-.755 1.672-.524 2.9-1.41 3.686-2.659.786-1.269 1.178-3.021 1.178-5.257Z"
          fill="#333"
          fillRule="nonzero"
        />
      </g>
    </svg>
  )
}
